import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { EventCard } from "@/components/EventCard";
import { eventPath } from "@/lib/eventPath";

/** Public list of a club's events (published + past/inactive), shown on the
 *  club's public page. Hidden entirely when the club has no public events. */
export function ClubEventsPublicList({ clubId }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(["comunidade", "common"]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get(`/api/clubs/${clubId}/events`)
      .then((res) => {
        if (cancelled) return;
        const pub = (res.data.events || []).filter((e) => e.status === "published" || e.status === "inactive");
        setEvents(pub);
      })
      .catch(() => { if (!cancelled) setEvents([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [clubId]);

  if (loading || events.length === 0) return null;

  return (
    <div className="mt-6" data-testid="club-detail-events">
      <div className="flex items-center gap-2 mb-4">
        <CalendarDays className="h-5 w-5 text-primary" />
        <h2 className="text-lg font-bold">{t("comunidade:events_section.overline", "Eventos")}</h2>
        <span className="text-sm text-muted-foreground">({events.length})</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {events.map((event) => (
          <EventCard key={event.event_id} event={event} onOpen={() => navigate(eventPath(event), { state: { from: location.pathname, fromKey: "clube" } })} />
        ))}
      </div>
    </div>
  );
}

export default ClubEventsPublicList;
